export default "__VITE_ASSET__DvzrWyfK__"